<template>
  <v-tour name="tour" :steps="steps" :options="options" :callbacks="callbacks">
  </v-tour>
</template>

<script>
export default {
  name: "ContractsTourComponent",
  data() {
    return {
      callbacks: {
        onSkip: this.tourStepFinish,
        onFinish: this.tourStepFinish
      },
      options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Cerrar",
          buttonPrevious: "Anterior",
          buttonNext: "Continuar",
          buttonStop: "Finalizar"
        }
      },
      steps: [
        {
          target: "#app",
          content: `
            <h5>Paso 1 de 3</h5>
            <h6>Empieza desde una plantilla</h6>
            <p>Elige una plantilla pre-armada o crea la tuya desde cero. Cláusulas listas para arrendamiento, servicios, NDA y más.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 2 de 3</h5>
            <h6>Personaliza con variables dinámicas</h6>
            <p>Inserta datos del cliente, montos y fechas con un clic. El editor reemplaza las variables automáticamente al generar el contrato.</p>
          `
        },
        {
          target: "#app",
          content: `
            <h5>Paso 3 de 3</h5>
            <h6>Descarga, envía o firma electrónicamente</h6>
            <p>Genera el PDF final, descárgalo o envíalo a firma digital. Todos tus contratos quedan organizados en un solo lugar.</p>
          `
        }
      ]
    };
  },
  methods: {
    tourStepFinish() {
      const userConfigGeneral = {
        is_contracts_tour_completed: 1
      };
      this.$store.dispatch("userConfigGeneralUpdated", userConfigGeneral);
    }
  },
  mounted() {
    this.$tours["tour"].start();
  }
};
</script>

<style lang="scss" scoped></style>
